import type { Infer, Struct } from 'superstruct';
import { optional, partial, record } from 'superstruct';

import { DataTableItemType } from './data-table-item-type';
import { ViewColumnTemplateSettingsDto } from './view-column-template-settings.dto';

export const EditColumnTemplateSettingsDto = partial(
	ViewColumnTemplateSettingsDto
);

export type EditColumnTemplateSettingsDto = Infer<
	typeof EditColumnTemplateSettingsDto
>;

export const EditFullColumnTemplateSettingsDto: Struct<
	EditFullColumnTemplateSettingsDto,
	null
> = record(DataTableItemType, optional(EditColumnTemplateSettingsDto));

// Superstruct does not type this as a partial record, but will accept such a
// value as valid. We need partial for some type checking.
export type EditFullColumnTemplateSettingsDto = Partial<
	Record<DataTableItemType, EditColumnTemplateSettingsDto | undefined>
>;
